export class Layout_Switcher {

    constructor ( options ) {
        this.options = options
    }

    initfilter () {
        const selectbox = $( '.select-box' )
        const action_item = $( '.action-item' )

        /**
         * init Select 2 without search
         */
        selectbox.select2( {
            minimumResultsForSearch: -1,
        } )

        /**
         * Main action
         */
        action_item.click( ( e ) => {

            let me = e.target
            action_item.removeClass( 'active' )
            $( me ).addClass( 'active' )

            if ( $( me ).hasClass( 'grid' ) ) {
                this.options.list_container
                    .removeClass( 'list' )
                    .addClass( 'grid' )

                if ( typeof this.options.action_click === 'function' ) {
                    this.options.action_click( 'create' )
                }
            }

            if ( $( me ).hasClass( 'list' ) ) {
                this.options.list_container
                    .removeClass( 'grid' )
                    .addClass( 'list' )

                if ( typeof this.options.action_click === 'function' ) {
                    this.options.action_click( 'destroy' )
                }
            }
        } )

    }

}


// WEBPACK FOOTER //
// ./scripts/components/layout-switcher.js